export default function () {
  let signalList,
    signalCounts,
    candleStickPatterns,
    mySignals,
    allSymbols,
    allStocks,
    allSector,
    sectorDetail,
    historyDataSearch,
    latestFiscalYearQuarter,
    allBrokers,
    floatRes,
    floatCapData,
    highCapStocks,
    midCapStocks,
    lowCapStocks,
    ultraLowCapStocks;
  let floatCapDataSymbol = {};

  return {
    signalList,
    signalCounts,
    candleStickPatterns,
    mySignals,
    allSymbols,
    allStocks,
    allSector,
    sectorDetail,
    historyDataSearch,
    latestFiscalYearQuarter,
    allBrokers,
    floatCapData,
    highCapStocks,
    midCapStocks,
    lowCapStocks,
    ultraLowCapStocks,
    floatCapDataSymbol,
    floatRes,
  };
}
